export default __webpack_public_path__ + "4d3684a6b634ab0703082a4a4ed89c20.png";